import { render, staticRenderFns } from "./Productmanagercommunicationproject.vue?vue&type=template&id=f9dcd574"
import script from "./Productmanagercommunicationproject.vue?vue&type=script&lang=js"
export * from "./Productmanagercommunicationproject.vue?vue&type=script&lang=js"
import style0 from "./Productmanagercommunicationproject.vue?vue&type=style&index=0&id=f9dcd574&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports